/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Selector_Manage_ModelsInputs */



/**
* | output |
* | --- |
* | "Manage models" |
*
* @param {Model_Selector_Manage_ModelsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_selector_manage_models = /** @type {((inputs?: Model_Selector_Manage_ModelsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Selector_Manage_ModelsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Modelle verwalten")
	return /** @type {LocalizedString} */ ("Manage models")
});